// src/layouts/LoggedInLayout/LoggedInLayout.tsx
import React, { useState, Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/PageLayout/PrivateLayout/Header/Header";
import Sidebar from "@/PageLayout/PrivateLayout/Sidebar/Siderbar";
import { LoadingSpinner } from "@/Components/common";
import "./LoggedInLayout.css";

const LoggedInLayout: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="logged-in-container">
      {/* Header */}
      <div className="logged-in-header-wrapper">
        <Header
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
      </div>

      {/* Mobile Drawer – ALWAYS EXPANDED */}
      <div
        className={`mobile-sidebar-overlay ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMobileMenuOpen(false)}
      />
      <div className={`mobile-sidebar-drawer ${isMobileMenuOpen ? 'open' : ''}`}>
        <button
          className="mobile-sidebar-close"
          onClick={() => setIsMobileMenuOpen(false)}
          aria-label="Close menu"
        >
          ×
        </button>
        <Sidebar forceExpanded={true} />   {/* THIS LINE CHANGED */}
      </div>

      {/* Desktop Layout */}
      <div className="logged-in-main">
        {/* Desktop Sidebar – normal hover behavior */}
        <div className="logged-in-sidebar-wrapper">
          <Sidebar />   {/* No prop = normal hover expand */}
        </div>

        <div className="logged-in-content">
          <Suspense fallback={<LoadingSpinner fullScreen size="lg" />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default LoggedInLayout;